import { Link } from 'react-router-dom';

export default function AppDownload() {
  return (
    <section className="py-12 md:py-16">
      <div className="site-container">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-600 via-primary-700 to-accent-800">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20flowing%20gradient%20waves%2C%20modern%20tech%20background%2C%20warm%20golden%20and%20amber%20tones%2C%20smooth%20curves%2C%20minimalist%20design%2C%20digital%20art%20style&width=1280&height=400&seq=app-download-bg-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
                下载蚂蚁影视APP
              </h2>
              <p className="text-sm md:text-base text-background-200 mb-6 leading-relaxed max-w-md">
                随时随地，想追就追。支持iOS和Android，下载安装即可畅享高清观影体验。
              </p>
              <div className="flex items-center gap-3 justify-center lg:justify-start flex-wrap">
                <Link
                  to="/about"
                  className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  <span>iOS 下载</span>
                </Link>
                <Link
                  to="/about"
                  className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/20 text-background-50 border border-background-50/30 text-sm font-medium hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  <span>Android 下载</span>
                </Link>
              </div>
              <p className="text-xs text-background-400 mt-4">
                已有超过 <strong className="text-background-200">500万</strong> 用户下载使用
              </p>
            </div>

            <div className="flex-shrink-0">
              <div className="w-40 md:w-48 h-40 md:h-48 flex items-center justify-center rounded-2xl bg-background-50/10 backdrop-blur-sm border border-background-50/20">
                <div className="text-center">
                  <i className="ri-qr-code-line text-6xl md:text-7xl text-background-50"></i>
                  <p className="text-background-300 text-xs mt-2">扫码下载</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}